import React from "react"

// import VideoPlayer from "react-video-js-player"
import VideoPlayer from "./video-player"

export const isVideoType = src => {
  const types = ["mp4", "mov"]
  return types.includes(src.split(".").pop())
}

const Image = ({ alt, src }) => {
  return isVideoType(src) ? (
    <VideoPlayer src={src} style={{ height: "100vh", minHeight: "100%" }} />
  ) : (
    <img alt={alt} src={src} />
  )
}

export default Image
